import { Container, Graphics, Rectangle, Text } from "pixi.js"
import { BUTTON_SIZES } from "./ui_tokens"
import { DEFAULT_FONT_FAMILY, TEXT_ROLES } from "../text/typography"
import { BUILDING_SHAPES, BuildingShape } from "../../../../building_shapes"
import { createToggleButton } from "./button_factory"
import { UiButton } from "./ui_button"
import { SCALER } from "../../../../client_util"

export class BuildingShapePalette extends Container {
    private background = new Graphics()
    private buttons = new Map<BuildingShape, UiButton>()
    private glyphs = new Map<BuildingShape, Graphics>()
    private caption = new Text("", { fontFamily: DEFAULT_FONT_FAMILY, fontSize: TEXT_ROLES.compactLabel.fontSize, fill: 0xffd166 })
    private hint = new Text("Scroll or click · drag to draw", { fontFamily: DEFAULT_FONT_FAMILY, fontSize: TEXT_ROLES.compactCaption.fontSize, fill: 0xaeb8c5 })
    private signature = ""
    private locked = false

    constructor(onSelect: (shape: BuildingShape) => void) {
        super()
        this.visible = false
        this.zIndex = 60002
        this.scale.y = 1 / SCALER
        this.interactive = true
        this.hitArea = new Rectangle(0, 0, 164, 78)
        this.background.beginFill(0x000000, 0.2).drawRoundedRect(0, 3, 164, 78, 9).endFill()
        this.background.lineStyle(1, 0x657080, 0.8).beginFill(0x20262d, 0.96).drawRoundedRect(0, 0, 164, 78, 9).endFill()
        this.addChild(this.background)
        this.caption.position.set(10, 7)
        this.hint.position.set(10, 62)
        this.addChild(this.caption, this.hint)
        BUILDING_SHAPES.forEach((shape, index) => {
            const button = createToggleButton({ label: "", iconOnly: true, selected: false,
                width: 46, height: BUTTON_SIZES.medium.height, size: "medium", theme: "slate", activation: "press",
                onClick: () => { if (!this.locked) onSelect(shape) } })
            button.position.set(9 + index * 50, 25)
            // Shape artwork belongs to this palette; the button owns its plate and input.
            const glyph = new Graphics()
            button.addChild(glyph)
            this.glyphs.set(shape, glyph)
            this.buttons.set(shape, button)
            this.addChild(button)
        })
    }

    setState = (visible: boolean, shape: BuildingShape, locked: boolean, hollow: boolean) => {
        this.visible = visible
        this.locked = locked
        const signature = `${shape}:${locked}:${hollow}`
        if (signature === this.signature) return
        this.signature = signature
        this.caption.text = `${shape[0].toUpperCase() + shape.slice(1)} · ${locked ? "drawing" : shape === "line" ? "stroke" : hollow ? "outline" : "filled"}`
        this.hint.text = locked ? "Release to start printing" : "Scroll or click · drag to draw"
        this.buttons.forEach((button, candidate) => {
            const selected = candidate === shape
            button.setEnabled(!locked)
            button.setSelected(selected)
            const glyph = this.glyphs.get(candidate)
            glyph.clear().lineStyle(1.5, selected ? 0xffd166 : 0xd0d8e2)
            if (!hollow && candidate !== "line") glyph.beginFill(selected ? 0xffd166 : 0xd0d8e2, 0.3)
            if (candidate === "rectangle") glyph.drawRect(13, 8, 20, 15)
            else if (candidate === "ellipse") glyph.drawEllipse(23, 15.5, 11, 8)
            else glyph.moveTo(13, 22).lineTo(33, 9)
            if (!hollow && candidate !== "line") glyph.endFill()
        })
    }
}
